import { ReviewsList } from "../Model/companyReviewsObjects";

export const REVIEWS_LIST = "REVIEWS_LIST";

const initialState = new ReviewsList({}, null); 

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REVIEWS_LIST:
            return action.payload;
        default:
            return state;
    }
}

const storeName = "reviewsList"

const storeMapping = {[storeName]: reducer};

export const reviewsListSelector = (state) => state[storeName];

export default storeMapping;
